// extracted by mini-css-extract-plugin
export default {"component":"style_component__bl6re","content":"style_content__2c-9X","bg_main":"style_bg_main__B7sXJ","bg_top":"style_bg_top__LQfwA"};